'use strict';

exports.Heading = require('./Heading');
exports.HeadingCaption = require('./HeadingCaption');


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-heading/lib/index.js
// module id = 59
// module chunks = 0